// extracted by mini-css-extract-plugin
export var documentation = "_l7-1";
export var menu = "_l7-0";